module.exports = __webpack_public_path__ + "img/a7fcffa2257d1943ce801df0db7b565d.png";